import { useState } from "react";
import CRM_API from "../../api/crmApi";

export default function CrmFollowupPanel({ leadId, refresh, currentStatus }) {
  const [remark, setRemark] = useState("");
  const [status, setStatus] = useState(currentStatus || "");
  const [temperature, setTemperature] = useState("");
  const [nextFollowup, setNextFollowup] = useState("");

  const addFollowup = async () => {
    const user_id = localStorage.getItem("crm_user_id");
    try {
      await CRM_API.post("/followups/add", {
        lead_id: leadId,
        counsellor_id: user_id,
        remark: remark || null,
        status: status || null,
        temperature: temperature || null,
        next_followup: nextFollowup || null,
      });
      setRemark("");
      setTemperature("");
      setNextFollowup("");
      refresh();
    } catch (error) {
      console.log("Followup error", error);
    }
  };

  return (
    <div>
      <textarea
        placeholder="Remark"
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
        className="form-control mb-2"
        rows={4}
        style={{ resize: "vertical" }}
      />

      <select
        value={status}
        onChange={(e) => setStatus(e.target.value)}
        className="form-select mb-2"
      >
        <option value="">Select Status</option>
        <option value="new">New</option>
        <option value="contacted">Contacted</option>
        <option value="interested">Interested</option>
        <option value="converted">Converted</option>
        <option value="dropped">Dropped</option>
      </select>

      <select
        value={temperature}
        onChange={(e) => setTemperature(e.target.value)}
        className="form-select mb-2"
      >
        <option value="">Select Temperature</option>
        <option value="cold">Cold</option>
        <option value="warm">Warm</option>
        <option value="hot">Hot</option>
      </select>

      <input
        type="date"
        value={nextFollowup}
        onChange={(e) => setNextFollowup(e.target.value)}
        className="form-control mb-3"
      />

      <button onClick={addFollowup} className="btn btn-primary w-100">
        Save Followup
      </button>
    </div>
  );
}
